import React, { ReactElement, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
/**
 *
 * @param {*} preventPageChange : boolean, to check if event listener should be added
 * @param {*} actionOnPageChange : what to do when event is fetched
 * @param {*} dependencies : all dependencies for the hook
 */
const useBrowserNav = (preventPageChange, actionOnPageChange, dependencies, returnLocation) => {
	const history = useHistory()

	const onBackButtonEvent = (e) => {
		e.preventDefault()
		if (preventPageChange) {
			actionOnPageChange()
		} else {
			setTimeout(() => {
				if (
					window.location.href.includes(ROUTES.FORM_CONFIGURATION) ||
					window.location.href.includes(ROUTES.PTKM_CONFIGURATION)
				)
					history.push(returnLocation)
			}, 10)
		}
	}

	useEffect(() => {
		if (preventPageChange) {
			window.history.pushState(null, null, window.location.href)
		}
		window.addEventListener("popstate", onBackButtonEvent)
		return () => {
			window.removeEventListener("popstate", onBackButtonEvent)
		}
	}, [dependencies])
}

export default useBrowserNav
